import { Component, Prop, Vue } from 'vue-property-decorator';
import { settingsMap, markerMap, infoMarkerMap } from '@/api/Map';
import { AppModule } from '@/store/modules/app';
import { MapModule } from '@/store/modules/map';
import { getMarkers, setMarkers } from '@/helpers/compress';
import { ProfessionModule } from '@/store/modules/profession';
import { JobType } from '@/types/ProfessionType';
import { CompanyModule } from '@/store/modules/company';

declare const MarkerClusterer: any;

@Component({
  name: 'MapMixin',
})
export default class extends Vue {
  @Prop({ default: 0 }) private jobPageId!: number | undefined;

  get languageSid() {
    return AppModule.languageSid;
  }

  defaultLoadMap = true;

  getMapSetting = {} as any;

  getMapMarker = [] as any;

  setMarkerIds = [];

  mapLoad = false;

  // mapConfig = {} as any;

  jobs: any = null;

  messages = {} as any;

  google: any = null;

  bounds: any = null;

  markerCluster: any = null;

  map: any;

  totalMarkers = {} as any;

  get mapConfig() {
    return MapModule.mapConfig;
  }

  // check if map point for this user is exist on local storage
  get markerStore() {
    return getMarkers(`${this.mapConfig.data_date as string}`)
      ? JSON.parse(getMarkers(`${this.mapConfig.data_date as string}`) as string)
      : ([] as any);
  }

  get job_ids() {
    return MapModule.mapMarkersIds;
  }

  get isNotice() {
    return MapModule.noticeMapRedirect;
  }

  set_marker(lat_long_date: any, job_id: any) {
    const arr = lat_long_date ? lat_long_date.split('_') : [0, 0];
    const title = 'Click to show job information';
    const marker = this.get_marker(parseFloat(arr[0]), parseFloat(arr[1]), title);
    marker.job_id = [job_id];
    marker.jobs = 1;
    return marker;
  }

  get_marker(lat: any, lng: any, title: any) {
    return new this.google.maps.Marker({
      position: new this.google.maps.LatLng(lat, lng),
      title,
      icon: './m_1.png',
    });
  }

  unpack(data: string | any[]) {
    const result = [];
    for (let i = 0; i <= data.length; i += 2) result.push([data[i], data[i + 1]]);
    return result;
  }

  setInfoWindow(marker: any, job_id: any) {
    const infoWindow = new this.google.maps.InfoWindow({
      content: '',
    });
    this.google.maps.event.addListener(
      marker,
      'click',
      // eslint-disable-next-line no-shadow
      ((mapMarker, mapInfoWindow, map_job_id) => () => {
        if (mapInfoWindow) {
          mapInfoWindow.close();
        }
        mapInfoWindow.open(this.map, mapMarker);
        if (!this.messages[map_job_id]) {
          const params = {
            map_job_id,
            sid: this.languageSid,
          };
          mapInfoWindow.setContent('loading...');
          infoMarkerMap(params).then((data) => {
            this.messages[map_job_id] = data.jobinfo;
            mapInfoWindow.setContent(data.jobinfo);
          });
        } else {
          infoWindow.setContent(this.messages[map_job_id]);
        }
      })(marker, infoWindow, job_id),
    );
    return marker;
  }

  createMarkerCluster(markers: any) {
    this.markerCluster = new MarkerClusterer(this.map, markers, {
      // imagePath: './img/',
      zoomOnClick: false,
    });
    // eslint-disable-next-line no-underscore-dangle
    this.google.maps.event.addListener(this.markerCluster, 'clusterclick', (cluster: any) => {
      const marker = cluster.getMarkers();
      this.setMarkerIds = [];
      marker.forEach((val: any) => {
        this.setMarkerIds = this.setMarkerIds.concat(val.job_id);
      });
      // START ---- LOAD JOB
      MapModule.SetSelectedRegionJobs(this.setMarkerIds);
      MapModule.ResetMapListFilters();
      ProfessionModule.SetJobType(JobType.map);
      AppModule.SetVisibleMap(false);
      AppModule.SetVisibleJobs(true);
      // END ---- LOAD JOB

      this.$scrollTo('#googleMapScroll');
    });

    // eslint-disable-next-line no-shadow
    this.markerCluster.setCalculator((mapMarker: any, numStyles: any) => {
      let index = 0;
      let count = 0;
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < mapMarker.length; i++) {
        count += mapMarker[i].jobs;
      }
      let dv = count;
      while (dv !== 0) {
        // @ts-ignore
        dv = parseInt(dv / 10, 10);
        // eslint-disable-next-line no-plusplus
        index++;
      }

      index = Math.min(index, numStyles);
      return {
        text: count,
        index,
      };
    });
  }

  // InitializeMap
  initializeMap() {
    const mapContainer = this.$refs.googleMap;
    this.map = new this.google.maps.Map(mapContainer, this.mapConfig);

    this.google.maps.event.addListenerOnce(this.map, 'idle', async() => {
      MapModule.SetMapRedirect(false);

      this.mapLoad = true;
      this.createMarkerCluster(this.writeFilterMarker());
      this.mapLoad = false;
    });
  }

  initializeMapFilter() {
    const mapContainer = this.$refs.googleMap;
    this.map = new this.google.maps.Map(mapContainer, this.mapConfig);
    this.google.maps.event.addListenerOnce(this.map, 'idle', () => {
      this.mapLoad = true;
      this.filterMarkerMapApi()
        .then(() => {
          this.createMarkerCluster(this.writeFilterMarker());
          this.mapLoad = false;
        })
        .catch((e) => console.log(e));
    });
  }

  async loadMapOptions() {
    try {
      this.mapLoad = true;
      if (!this.mapConfig.data_date) {
        this.getMapSetting = await settingsMap({
          sid: this.languageSid,
        });
        this.mapConfig.center.lat = this.getMapSetting.latitude;
        this.mapConfig.center.lng = this.getMapSetting.longitude;
        this.mapConfig.zoom = this.getMapSetting.zoom;
        this.mapConfig.data_date = this.getMapSetting.data_date;
        this.mapConfig.mapTypeId = this.google.maps.MapTypeId.ROADMAP;
      }
      MapModule.SetMapConfig(this.mapConfig);
      if (this.markerStore.length) {
        this.getMapMarker = this.unpack(this.markerStore);
      } else {
        const tempGetMapMarker = await markerMap({ sid: this.languageSid, new: 1 });
        this.getMapMarker = this.unpack(tempGetMapMarker);
        this.addMarkerStore(tempGetMapMarker, this.mapConfig.data_date);
      }
      this.jobs = new Map(this.getMapMarker);
      this.mapLoad = false;
    } catch (error: any) {
      if (error && error.message) {
        console.log(error);
      }
    }
  }

  // MarkerStore
  // set map date field with user's id to the local storage
  addMarkerStore(items: any, date: string) {
    setMarkers(items, `${date}`);
  }

  // DefaultMarkerMap
  setZero() {
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const t in this.totalMarkers) {
      this.totalMarkers[t].jobs = 0;
      this.google.maps.event.clearInstanceListeners(this.totalMarkers[t]);
    }
  }

  defaultFilterMap() {
    // call when refresh button is clicked
    this.defaultLoadMap = true;
    // MapModule.UPDATE_MAP_ACTIVE_PROFESSION_GROUP();
    // MapModule.UPDATE_MAP_TIME_FACTOR();
    // MapModule.UPDATE_MAP_FILTERS();
    this.initializeMap();
    this.applyFilters();
  }

  // writeMarkerMap
  writeFilterMarker() {
    const markerso = {} as any;
    const markers = [] as any;
    let k = 0;
    let v = '';

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < this.job_ids.length; i++) {
      k = this.job_ids[i];
      v = this.jobs.get(this.job_ids[i]);
      if (!this.totalMarkers[v]) {
        markerso[v] = this.set_marker(v, k);
        this.totalMarkers[v] = markerso[v];
      } else if (markerso[v]) {
        markerso[v].jobs += 1;
        markerso[v].job_id.push(k);
      } else {
        markerso[v] = this.totalMarkers[v];
        markerso[v].jobs = 1;
        markerso[v].job_id = [k];
      }
    }

    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const o in markerso) {
      const marker = markerso[o];
      if (marker.jobs === 1) {
        markers.push(this.setInfoWindow(marker, marker.job_id[0]));
      } else {
        markers.push(marker);
      }
    }

    return markers;
  }

  writeMarker() {
    const markerso = {} as any;
    const markers = [] as any;
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of this.jobs) {
      if (!this.totalMarkers[value]) {
        markerso[value] = this.set_marker(value, key);
        this.totalMarkers[value] = markerso[value];
      } else if (markerso[value]) {
        markerso[value].jobs += 1;
        markerso[value].job_id.push(key);
      } else {
        markerso[value] = this.totalMarkers[value];
        markerso[value].jobs = 1;
        markerso[value].job_id = [key];
      }
    }
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const o in markerso) {
      let marker = [];
      if (o !== 'undefined') {
        marker = markerso[o];
        if (marker.jobs === 1) {
          markers.push(this.setInfoWindow(marker, marker.job_id[0]));
        } else {
          markers.push(marker);
        }
      }
    }
    this.createMarkerCluster(markers);
  }

  // FilterMarkerMap
  get mapType() {
    return MapModule.mapType;
  }

  async filterMarkerMapApi() {
    const params = {
      sid: this.languageSid,
      cluster_id: MapModule.mapClusterParams.cluster_id,
    };
    if (this.mapType !== JobType.cluster) {
      delete params.cluster_id;
    }
    await MapModule.GetMapMarkerJobs(params);
  }

  applyFilters() {
    this.setZero();

    this.mapLoad = true;
    this.filterMarkerMapApi()
      .then(() => {
        this.markerCluster.clearMarkers();
        this.createMarkerCluster(this.writeFilterMarker());
        this.mapLoad = false;
      })
      .catch((e) => console.log(e));
  }

  startRefreshMarkers() {
    // TODO: fix by moving applyFilters to vuex
    this.setZero();
    this.mapLoad = true;
    this.markerCluster.clearMarkers();
  }

  endRefreshMarkers() {
    // TODO: fix by moving applyFilters to vuex
    this.createMarkerCluster(this.writeFilterMarker());
    this.mapLoad = false;
  }
}
